import { Component, OnInit, Input } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { GlobalService } from '@common/global';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MailService } from '@services/mail.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-dreportabuse',
  templateUrl: './dreportabuse.component.html',
  styleUrls: ['./dreportabuse.component.sass']
})
export class DreportabuseComponent implements OnInit {
  @Input('app') app: string;
  @Input('res') res: object;
  @Input('compose_id') compose_id: string;
  title = "";
  site_url = '';
  reportForm: FormGroup;
  constructor(private _mail: MailService,private fb: FormBuilder, private _global: GlobalService, public ngxSmartModalService: NgxSmartModalService) {
    this.reportForm = this.fb.group({
      comment: []
    });
    this.site_url = this._global.SITE_URL;
  }

  ngOnInit() {
  }
  ngOnChanges() {
    this.title = this.app;
  }
  mailSend(){
    let r = this.reportForm.value;
    r = this._global.paramsRemoveNull(r);
    let p={
      component:'m',
      application:'mail',
      attachment:"{}",
      id:this.compose_id,
      subject:'Report '+this.app+' '+this._global.getVal(this.res,'id','')+ ' - '+this._global.getVal(this.res,'name',''),
      body:r['comment']+' <br/> '+this._global.getVal(this.res,'id',''),
      to:this._global.getVal(this._global.userSiteDetails(), 'helpEmail', '')
    };
    this._mail.send(p).subscribe(
      data => {
        this._global.showMessage({ "type": 'success', "message": 'Mail send success' });
      },
      error => {
        console.log("error", JSON.stringify(error));
      }); 
  }

}
